import type { CollectionPack } from '@shared/api';

// Initial economy: one XP and one coin per first-time solved question, no completion bonus.
// Public server totals, when available, override the preview from game-mechanics.md §8.
export const getCollectionRewards = (pack: CollectionPack) => ({
  experience: pack.totalRewards?.exp ?? pack.questionIds.length,
  coins: pack.totalRewards?.coins ?? pack.questionIds.length,
});
